export default {
    "wishLists": "0662fafe7e6ac2e660dbeb095a15457e31ca4661bcadd9de7048c62e96b977e9",
    "createWishList": "66b848f38446a0b0e2b810651c28e44e785774f62ded7d5af353ba42eb17771a",
    "deleteWishList": "84849ceba16002e0cec8659fb7e69905a55fb964165c336e3082a419565dedcc",
    "updateWishList": "a1a25aed7f65c07d12db5cf12e85e24cefd09fbe883d33f6ba83fc5adea3f01a",
    "addProductsToWishList": "61b55ab263162ceed7ab78b9ee97dd4e9011aa3a1b8ef0b8f701bfdd4394ddc9",
    "removeProductsFromWishList": "71ac0f6af7ea50361e88c700c1425bb0002a0a196a5e7e090eea7a79e3f3dd68",
    "moveProductsBetweenWishLists": "32ead9145ced017e784f75f7beba28020c337ac35b522da889c26139901f90c7",
    "copyProductsBetweenWishLists": "59b9124a7fbc37b1d3dc72142085918870583a39d42c8739b6f820e8709a3229"
};
